import { omit } from 'lodash';
import { Action, Reducer } from 'redux';
import { isActionOf } from 'typesafe-actions';
import * as actions from './actions';

// TODO: review after https://github.com/wix-private/vmaf/issues/30
function wrapWithTemporaryInputReducer<
  S extends Record<string, any>,
  A extends Action<string>,
>(rootReducer: Reducer<S, A>, inputKeys: (keyof S)[]): Reducer<S, A> {
  return (state, action) => {
    if (isActionOf(actions.clearInput, action)) {
      state = omit(state, inputKeys) as any;
    }

    return rootReducer(state, action);
  };
}

export default wrapWithTemporaryInputReducer;
